import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";

import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";

import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

@inject("songListStore")
@observer
class NotificationTableHeader extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };
    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    <TableCell className="th-songlist nopad" padding="checkbox" style={{ width: "6%" }}>
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount && numSelected !== 0}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>

                    <TableCell className="th-songlist" key="createdAt" padding="default" sortDirection={orderBy === "createdAt" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "createdAt"} direction={order} onClick={this.createSortHandler("createdAt")}>
                                <Typography variant="subheading" className="head-title">
                                    Date
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="from" padding="default" sortDirection={orderBy === "from" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "from"} direction={order} onClick={this.createSortHandler("from")}>
                                <Typography variant="subheading" className="head-title">
                                From
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="generatedMessage" padding="default" sortDirection={orderBy === "generatedMessage" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "generatedMessage"} direction={order} onClick={this.createSortHandler("generatedMessage")}>
                                <Typography variant="subheading" className="head-title">
                                Message
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="mediaUrl" style={{ width: "10%" }}>
                        <Typography variant="subheading" className="head-title">
                            Action
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
        );
    }
}

NotificationTableHeader.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired
};

export default NotificationTableHeader;
